import { CheckboxItem, ItemIndicator } from "@radix-ui/react-dropdown-menu";
import { ReactNode, forwardRef } from "react";

const DropdownMenuCheckboxItem = forwardRef<
  React.ElementRef<typeof CheckboxItem>,
  React.ComponentPropsWithoutRef<typeof CheckboxItem> & { Icon?: ReactNode }
>(({ className, Icon, children, checked, ...props }, ref) => (
  <CheckboxItem
    ref={ref}
    className={`relative flex cursor-default select-none items-center rounded-sm py-1.5 pl-8 pr-2 text-sm outline-hidden transition-colors focus:bg-muted dark:bg-muted/10 focus:text-accent-foreground data-disabled:pointer-events-none data-disabled:opacity-50
      ${className}
    `}
    checked={checked}
    {...props}
  >
    <span className="absolute left-2 flex h-3.5 w-3.5 items-center justify-center">
      <ItemIndicator>{Icon}</ItemIndicator>
    </span>
    {children}
  </CheckboxItem>
));
DropdownMenuCheckboxItem.displayName = CheckboxItem.displayName;

export { DropdownMenuCheckboxItem };
